import Modalbox from '../utils/_modal-box'

export default function VideoModal () {
  setTimeout(() => new Modalbox('.open-video-modal'), 50)
}
